import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { REVIEW_RECORDINGS_REVIEW_TRANSCRIPTS_KB_ARTICLE_URL } from '../../constants/KnowledgeBaseUrls';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { ArtificialIntelligenceIcon } from 'foundations-assets/icons/components/ArtificialIntelligenceIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const attrs = {
  elements: {
    KnowledgeBaseButton
  },
  options: {
    url: REVIEW_RECORDINGS_REVIEW_TRANSCRIPTS_KB_ARTICLE_URL
  }
};
export const AIIcon = () => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: "recordingReviewComponents.participantMatching.aiIcon.aiIconTooltipText_jsx"
    }, attrs)),
    maxInlineSize: "200px",
    children: /*#__PURE__*/_jsx(View, {
      marginInlineStart: "100",
      children: /*#__PURE__*/_jsx(ArtificialIntelligenceIcon, {
        color: "icon-core-subtle",
        size: "100"
      })
    })
  });
};